<template>
  <div class="modal-column">
    <div class="padding flex-1">
      <Form style="padding: 10px;">
        <FormItem class="!pb-5px" label="银行科目">
          <div class="flex items-center">
            <Select :datas="subjectList" v-model="params.subjectId" :deletable="false"></Select>
          </div>
        </FormItem>
        <FormItem class="!pb-5px" label="对账日期">
          <div class="flex items-center">
            <DatePicker v-model="params.reconciliationDateStart"/>
            <span class="mx-8px">至</span>
            <DatePicker v-model="params.reconciliationDateEnd" />
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="modal-column-btn">
      <Button @click="$emit('close')" :loading="loading">取消</Button>
      <Button color="green" @click="cancelAllReconciliation" :loading="loading">确定</Button>
    </div>
  </div>
</template>

<script>

import {modal} from "heyui.ext";
import bankReconciliation from "@api/BankReconciliation";

export default {
  name: "CancelReconciliationOptions",
  props: {
    reconciliationDateStart: String,
    reconciliationDateEnd: String,
    subjectList: Array,
    subjectValue: String
  },
  data() {
    return {
      subjectId: null,
      params: {
        subjectId: null,
        reconciliationDateStart: null,
        reconciliationDateEnd: null
      },
      loading: false
    }
  },
  computed: {
    fileName() {
      if (this.file) {
        return this.file.name;
      }
      return '';
    }
  },
  methods: {
    cancelAllReconciliation(){
      this.loading = true
      if((this.params.reconciliationDateStart==null || this.params.reconciliationDateStart=="") && (this.params.reconciliationDateEnd==null || this.params.reconciliationDateEnd=="") ){
        this.$Message("请选择对账日期！")
        this.loading = false;
        return;
      }

      bankReconciliation.cancelAllReconciliation(this.params).then(({data}) => {
        this.$Message({type:"success",text:"取消对账完成！"})
        this.$emit('success', data);
      }).finally(() => {
        this.loading = false;
      })
    },
  },
  created() {
    this.params.subjectId = this.subjectValue;
    this.params.reconciliationDateStart = this.reconciliationDateStart;
    this.params.reconciliationDateEnd = this.reconciliationDateEnd;
  }
}
</script>
